import React, { useMemo } from 'react';
import { View } from 'react-native';
import { AppView, CardView, rem, Spacer, StatusBar, withAnimatedNavigationHeader, } from 'design-system';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import Text from 'design-system/Text';
import Squircle from 'design-system/Squircle';
import IconCheck from 'design-system/icons/IconCheck';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import SectionHeader from 'design-system/SectionHeader';
import useColors from 'hooks/useColors';
import { getSmartRuleCreatedTransactions } from 'actions';
import { formatDateForSectionHeaderWithDate } from 'utils';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import TransactionsPreview from '../../transactions/components/TransactionsPreview';
import { isWeb } from '../../../constants';
const strings = {
    title: 'Created transactions',
};
const SmartRuleCreatedTransactionsScreen = withAnimatedNavigationHeader(({ route, scrollHandler }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle);
    const ListFooterComponent = useMemo(() => (<>
            <Spacer.H16 />
            <SectionHeader style={styles.header}>
              {formatDateForSectionHeaderWithDate(route.params.createdAt)}
            </SectionHeader>
            <CardView style={styles.card}>
              <Squircle>
                <IconCheck thick color={colors.elements.secondary}/>
              </Squircle>
              <View style={styles.column}>
                <Text Text-16>Setup smart rule</Text>
                <Text TextThin-14 Secondary>
                  Smart rule doesn’t apply to transactions made before you set
                  up the rule
                </Text>
              </View>
            </CardView>
          </>), [
        colors.elements.secondary,
        route.params.createdAt,
        styles.card,
        styles.column,
        styles.header,
    ]);
    return (<AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <TransactionsPreview onScroll={scrollHandler} contentContainerStyle={paddingBottom} ListFooterComponent={ListFooterComponent} showEmpty={false} smallMargin={false} endpoint={(_, page) => getSmartRuleCreatedTransactions(route.params.id, page)}/>
        </AppView>);
}, ({ colors }) => ({
    title: strings.title,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styleSet = createStyleSheets((colors) => ({
    header: {
        marginHorizontal: rem(16),
    },
    card: {
        backgroundColor: colors.cards.onDark,
        flexDirection: 'row',
        alignItems: 'center',
        gap: rem(16),
        padding: rem(16),
    },
    column: {
        flex: 1,
    },
}));
export default SmartRuleCreatedTransactionsScreen;
